import {autobind} from 'core-decorators';
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import PDFJS from 'pdfjs-dist'; // eslint-disable-line import/no-unresolved
import PdfPage from './PdfPage';
import LoadingBlocking from '../components/loading/LoadingBlocking';
import styles from './pdfViewer.scss';
import {downloadPdf64Bit, generateBrowser, generatePdfOpenProps} from "../utils/pdfHelper";
import downloadIcon from "./public/download.png";
import { decodeDocument } from '../utils/documentsHelper';



@CSSModules(styles, {allowMultiple: true})
export default class PdfViewer extends React.Component {

  static propTypes = {
    pdfData: PropTypes.string.isRequired,
    isLiterallyPdf: PropTypes.bool,
    fileName : PropTypes.string,
  };

  static defaultProps = {
    isLiterallyPdf: false,
    fileName : '',
  };

  constructor(props) {
    super(props);
    this.state = {
      document: null,
      totalPages: 0,
      loadedPages: 0,
      isReadyToDownload : false,
      isDownloadButton : false,
      pages: []
    };
  }

  componentDidMount() {
    const source = {data: decodeDocument(this.props.pdfData)};
    const documentPromise = PDFJS.getDocument(source);

    documentPromise.then(
      (document) => {
        this.setState(() => {
          return {document, totalPages: document.numPages};
        }, () => {
          this.loadPage();
        });
      }
    );
  }

  @autobind
  loadPage() {
    const document = this.state.document;
    const pages = this.state.pages;
    const totalPages = this.state.totalPages;
    const nextPageNumber = this.state.loadedPages + 1;
    if (nextPageNumber > totalPages) {
      return;
    }
    document.getPage(nextPageNumber).then(
      (page) => {
        this.setState(() => {
          return {loadedPages: nextPageNumber,
                  isReadyToDownload: true,
                  isDownloadButton : this.props.isLiterallyPdf,
                  pages: [].concat(pages, [page])};
        });
      }
    );
  }

  onDownload = (pdfData) => {
    const fileName = this.props.fileName;
    const data = generatePdfOpenProps(pdfData, fileName);
    downloadPdf64Bit(data.href , fileName , false);
  };

  onPdfPreview = (pdfData) => {
    const  fileName = this.props.fileName;
    // const  src = `data:application/pdf;headers=filename%3D${fileName};base64, ${encodeURI(pdfData)}` ;
    const data = generatePdfOpenProps(pdfData, fileName);
    const src = `data:application/pdf;headers=filename%3D${fileName};base64, ${encodeURI(pdfData)}` ;
    const browser = generateBrowser();
   // const isMobile = getIfMobile();
    if(browser.name === 'safari') {
      this.state.isReadyToDownload && downloadPdf64Bit(pdfData, fileName);
      return  <iframe width="100%"
                      height="100%"
                      src={data.href} />;
    } else if(browser.name  === "ios"){
      return downloadPdf64Bit(src , fileName , false);
     }
    // else if (isMobile) {
    //   this.state.isReadyToDownload &&  this.onDownload(this.props.pdfData);
    // }
    return (<div styleName="container-pdf">
            {this.state.isDownloadButton &&
            <div styleName="nav-bar-pdf">
              <img src={downloadIcon}
                   alt="Pdf icon"
                   styleName="download-pdf"
                   onClick={() => this.onDownload(this.props.pdfData) }/>
            </div>}
            {this.renderPdfAsCanvas()}
           </div>);
  };

  renderPdfAsCanvas = ( ) => {
    return (<div styleName={`pdf-viewer-wrap ${this.state.isDownloadButton ? "pdf-viewer-wrap-extension" : ""}`}>
      <div styleName="pdf-viewer">
        {!this.state.loadedPages && <LoadingBlocking />}
        {this.state.pages.map((page, index) => {
          return <PdfPage key={index} page={page} pageDoneCallback={this.loadPage}/>;
        })}
      </div>
    </div>);
  };

  render() {
    return (
      <div styleName="container-pdf">
        {this.props.isLiterallyPdf
          ?
          this.onPdfPreview(this.props.pdfData)
          :
          this.renderPdfAsCanvas()}
      </div>
    );
  }
}






// WEBPACK FOOTER //
// ./src/pdf/PdfViewer.js